/**
 * The state pill the review tabs and the registry share (docs/ux/casefile.md,
 * docs/ux/registry.md): a word, a tone, an optional icon; never colour
 * alone. Tones follow DESIGN.md's status chip tone map.
 */

import { cn } from 'cn';
import type { ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';

export type ChipTone = 'neutral' | 'mine' | 'warning' | 'done' | 'error';

const CHIP_TONE: Record<ChipTone, string> = {
  neutral: 'bg-beam-cream-deep text-foreground border-beam-line',
  mine: 'bg-beam-harbour/55 text-beam-harbour-ink border-transparent',
  warning: 'bg-beam-warning-bg text-beam-warning border-transparent',
  done: 'bg-beam-sage/55 text-beam-sage-ink border-transparent',
  error: 'bg-beam-error-bg text-beam-error border-transparent',
};

export function StateChip({ label, tone, icon, attrs, className, size = 'md' }: { label: string; tone: ChipTone; icon?: ReactNode; attrs?: Record<string, string>; className?: string; size?: 'sm' | 'md' }) {
  return (
    <Badge variant="outline" {...attrs} className={cn('gap-1 rounded-full font-medium', size === 'sm' ? 'h-[22px] px-2.5 text-xs' : 'h-7 px-3 text-[13px]', CHIP_TONE[tone], className)}>
      {icon}
      {label}
    </Badge>
  );
}
